<template>
  <div
    v-if="!item.hidden"
    class="vsm-item"
    :class="[
      {'first-item' : firstItem},
      {'active-item' : active},
      {'parent-active-item' : childActive},
      {'open-item' : itemShow},
    ]"
  >
    <router-link
      class="vsm-link"
      :class="item.class"
      :to="item.href"
      :disabled="item.disabled"
      :event="item.disabled ? '' : 'click'"
      v-bind="item.attributes"
      @click.native="clickEvent"
    >
      <span v-if="item.icon" class="vsm-icon">
        <icool-icon :icon="item.icon" class="m-1" />
      </span>
      <template>
        <span
          v-if="item.badge"
          :style="[(hasChild ? {'margin-right' : '30px'} : '')]"
          class="vsm-badge"
          :class="[item.badge.class ? item.badge.class : 'default-badge']"
          v-bind="item.badge.attributes"
        >{{ item.badge.text }}</span>
        <span class="vsm-title">{{ item.title }}</span>
        <round-icon-button
          icon="angle-right"
          v-if="hasChild && enableCollapsing"
          class="vsm-arrow"
          :class="{'open-arrow' : itemShow}"
          @click.stop="expandClickEvent"
        />
      </template>
    </router-link>
    <template v-if="hasChild">
      <transition
        name="expand"
        @enter="expandEnter"
        @afterEnter="expandAfterEnter"
        @beforeLeave="expandBeforeLeave"
      >
        <div
          v-if="itemShow || !enableCollapsing"
          class="vsm-dropdown"
        >
          <div class="vsm-list">
            <sub-item
              v-for="(subItem, index) in item.child"
              :key="index"
              :item="subItem"
            />
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import SubItem from './SubItem.vue';
import { itemMixin, animationMixin } from '../mixin';
import RoundIconButton from '@/components/utils/RoundIconButton';

export default {
  components: {
    RoundIconButton,
    SubItem,
  },
  mixins: [itemMixin, animationMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    firstItem: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
